export enum EnumEscala {
  CRITICO = 1,
  ATENCAO = 2,
  RAZOAVEL = 3,
  SAUDAVEL = 4,
  IDEAL = 5
}
